import { render, staticRenderFns } from "./ShowSeries.vue?vue&type=template&id=4da4ea1a&scoped=true&"
import script from "./ShowSeries.vue?vue&type=script&lang=js&"
export * from "./ShowSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da4ea1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4da4ea1a')) {
      api.createRecord('4da4ea1a', component.options)
    } else {
      api.reload('4da4ea1a', component.options)
    }
    module.hot.accept("./ShowSeries.vue?vue&type=template&id=4da4ea1a&scoped=true&", function () {
      api.rerender('4da4ea1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Series/ShowSeries.vue"
export default component.exports